import React, {PureComponent} from 'react';
import { Link } from "react-router-dom";
import {withTranslation} from 'react-i18next'
import {toast} from "react-toastify";
import Aux from "../../../hoc/Auxiliary"

class Alert extends PureComponent {
    constructor(props) {
        super(props);

        const {t} = this.props;

        this.state = {
            toast_duration: 10000
        }
    }

    render() {
        if (!this.props.item) return true

        const {toast_duration} = this.state;

        let html = null;

        if (this.props.item.type == 'toast'){
            const content =
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t(this.props.item.text,this.props.item.data)}
                </div>;

            const options = {
                autoClose: toast_duration
            };

            switch(this.props.type)
            {
                case 'danger':
                    toast.error(content,options)
                    break;
                case 'warning':
                    toast.warning(content,options)
                    break;
                case 'success':
                    toast.success(content,options)
                    break;
                default:
                    toast.info(content,options)
                    break;
            }
        }
        else{
            let icon = '';
            if(this.props.item.customIcon){
                icon = this.props.item.customIcon;
            } else {
                switch(this.props.type){
                    case 'danger':
                    case 'warning':
                        icon = 'fas fa-exclamation-circle';break;
                    case 'success':
                        icon = 'fas fa-check-circle';break;
                    case 'info':
                    case 'notice':
                    default:
                        icon = 'fas fa-info-circle';break;
                }
            }
            let fullClassName = "message message--"+this.props.type+' '+this.props.item.additionalClasses;
            let InnerContent = (
                <Aux>
                    <div className="message__icon">
                        <i className={icon}></i>
                    </div>
                    <div className="message__content">{this.props.t(this.props.item.text,this.props.item.data)}</div>
                    {this.props.item.link ?
                        (<div className="message__actions">
                            <div className="message__action action--arrow">
                                <i className="message__action__icon fas fa-angle-right" aria-hidden="true"></i>
                            </div>
                        </div>)
                    : null}
                </Aux>
            );
            html = (
                <Aux>
                    {this.props.item.link ?
                        (<Link to={this.props.item.link} className={fullClassName}>{InnerContent}</Link>)
                        : (<div className={fullClassName}>{InnerContent}</div>)
                    }
                </Aux>
            );
        }

        return html;
    }
}

export default withTranslation()(Alert);
